import { render } from "./SwitchPlatformMenu.vue?vue&type=template&id=3f4c6778&scoped=true"
import script from "./SwitchPlatformMenu.vue?vue&type=script&lang=js"
export * from "./SwitchPlatformMenu.vue?vue&type=script&lang=js"

import "./SwitchPlatformMenu.vue?vue&type=style&index=0&id=3f4c6778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4c6778"]])

export default __exports__